import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import { Logger } from '@rover/rsdk/src/modules/Logging';
import emitMetric from '@rover/utilities/emitMetric';

import { OwnerConversionMemberProfileSectionInteractEvent } from '../analyticsEvents';
import { SitterProfileVersion } from '../hooks/useRevampProfileContext';

export const sendSectionInteractionEvent = (
  section: string,
  options?: {
    interactionType?: 'expand' | 'collapse';
    pageVariant?: SitterProfileVersion;
  }
): void => {
  emitAnalyticsEvent(
    new OwnerConversionMemberProfileSectionInteractEvent({
      profileSection: section,
      interactionType: options?.interactionType || 'expand',
      ...(options?.pageVariant && { pageVariant: options.pageVariant }),
    })
  );
  emitMetric('sitter_profile_section_clicked', { section });
  Logger.info('sitter_profile_section_clicked', { section });
};
